import React from 'react'
import {Trans} from '@lingui/macro'
import {Button} from 'components/UI/Button/Button'
import { PlusIcon } from "@heroicons/react/outline";


// Type
export type typeDUsersManagementActions = {
    onClickAdd: () => void
}


// Component
export const DUsersManagementActions: React.FC<typeDUsersManagementActions> = ({onClickAdd}) => {
    return(
        <>
            <Button secondary={true} buttonClassName="flex-initial" type="button" label={<Trans>Add</Trans> } icon={<PlusIcon className="w-5 h-5 mr-1"/>} onClick={onClickAdd}/>
        </>
    )
}
